// Core
import { useState, useCallback, useRef } from 'react';
import { FaPlus } from 'react-icons/fa6';
import {
  Link,
  Route,
  Switch,
  Redirect,
  useRouteMatch,
  useLocation,
  useHistory
} from 'react-router-dom';
import { 
  Box, Flex, Text, useColorModeValue,
  FormControl,
  SimpleGrid,
  InputGroup,
  InputLeftElement,
  Input,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';

// Components
import Groups from './Groups.js';
import Edit from './Edit.js';
import Liked from './components/Liked.js';

function Group(props) {
  const { path, url } = useRouteMatch();

  const location = useLocation();
  const isActive = (path) => location.pathname.includes(path);

  const textColor = useColorModeValue('blue.800', 'white');
  const borderColor = useColorModeValue(
    'rgba(255, 255, 255, 0.10)',
    'rgba(255, 255, 255, 0.10)',
  );

  const [offset, setOffset] = useState(0);
 
  const [isLoadingPage, setIsLoadingPage] = useState(false);
  
  const history = useHistory();
  const onNewButtonClicked = useCallback(() => {
    history.push('/group-profile/new');
  }, [history]);
  const onBackClicked = useCallback(() => {
    history.push('/group');
  }, [history]);
    const onBackListClicked = useCallback(() => {
    history.push('/group-profile');
  }, [history]);

  return (
    <Box p="130px 15px 24px 15px" maxH="calc(100vh - 0px)" pb="130px" overflowY="auto">
      <Box mt="0px" mb="50px" direction="column">
        <Box align="left" mt="32px">
          <Switch>
            <Route path={`${path}/:id/users`} render={() => <Liked onBackListClicked={onBackListClicked} isLoadingPage={isLoadingPage} setIsLoadingPage={setIsLoadingPage} />} />
            <Route
              path={`${path}/:id(new|\\d+)`}
              render={() => <Edit dataUser={props.object} />}
            />
            <Route
              path={`${path}`}
              render={() => <Groups 
                dataUser={props.object} 
                offset={offset}
                onNewButtonClicked={onNewButtonClicked}
                onBackClicked={onBackClicked}
                setOffset={setOffset}
                isLoadingPage={isLoadingPage} 
                setIsLoadingPage={setIsLoadingPage} />}
            />
            <Redirect from={`${path}*`} to={`${path}`} />
          </Switch>
        </Box>
      </Box>
    </Box>
  );
}

export default Group;
